import React from 'react'
import LiveView from './LiveView'
import { WallboxHardwareModel } from 'src/Libs/wallboxes/models'
import { PowermeterHardwareModel } from 'src/State/Storage/StorageModel'

export interface OfflineLiveViewProps {
  wallboxes: WallboxHardwareModel[]
  consumers?: PowermeterHardwareModel[]
  producers?: PowermeterHardwareModel[]
  isFarm?: boolean
  offlineIcon: React.ReactNode
  shallowLiveView?: boolean
  storageId?: string
}

const OfflineLiveView: React.FC<OfflineLiveViewProps> = ({
  wallboxes,
  consumers,
  producers,
  offlineIcon,
  shallowLiveView,
  storageId,
  isFarm = false,
}) => {
  return (
    <LiveView
      batteryHomePower={0}
      homeBatteryPower={0}
      homeWallboxPower={0}
      wallboxes={wallboxes}
      consumers={consumers}
      producers={producers}
      homeNetworkPower={0}
      networkHomePower={0}
      pvHomePower={0}
      homeConsumerPower={0}
      consumption={0}
      trackerHomePower={0}
      isFarm={isFarm}
      liveData={undefined}
      offlineIcon={offlineIcon}
      shallowLiveView={shallowLiveView}
      storageId={storageId}
    />
  )
}

export default OfflineLiveView
